<template>
  <div>
    <br>
    &lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot; standalone=&quot;yes&quot;?&gt;
    &lt;div&gt;
    &lt;div&gt;
    <div v-for="kreis in landkreise" :key="kreis.gkz" class="kreis">
      &lt;div&gt;
      &lt;Landkreis_NAME&gt;{{kreis.title}} &lt;&#x2F;Landkreis_NAME&gt;<br>
      &lt;Landkreis_PARTEIEN&gt;
      <span v-for="party in kreis.cols" :key="party.label">
        {{party.label}} &lt;Landkreis_PARTEIEN_BOLD&gt;{{format(party.percent)}} &lt;&#x2F;Landkreis_PARTEIEN_BOLD&gt; ({{format(party.percentOld)}});
      </span>
      &lt;&#x2F;Landkreis_PARTEIEN&gt;<br><br>
      <div>&lt;div&gt;
        &lt;div&gt;
          &lt;Kommune_NAME&gt;» Kommunen:&lt;&#x2F;Kommune_NAME&gt;
        &lt;&#x2F;div&gt;
        <div v-for="gemeinde in gemeinden.filter(gemeinde => gemeinde.gkz.slice(0,3) == kreis.gkz)" :key="gemeinde.GKZ">
          &lt;div&gt;
            &lt;Kommune_NAME&gt;{{gemeinde.title}}: &lt;&#x2F;Kommune_NAME&gt;
            &lt;Kommune_PARTEIEN&gt;
            <span v-for="party in gemeinde.cols" :key="party.label">
              {{party.label}} &lt;Kommune_PARTEIEN_BOLD&gt;{{format(party.percent)}} &lt;&#x2F;Kommune_PARTEIEN_BOLD&gt; ({{format(party.percentOld)}});
            </span>
            &lt;&#x2F;Kommune_PARTEIEN&gt;
          &lt;&#x2F;div&gt;
        </div>
      &lt;&#x2F;div&gt;</div>
      &lt;&#x2F;div&gt;
    </div>
    &lt;&#x2F;div&gt;<br>

    &lt;div&gt;
    <div v-for="kreis in kfs" :key="kreis.gkz" class="kreis">
      &lt;div&gt;
      &lt;Stadt_NAME&gt;{{kreis.title}} &lt;&#x2F;Stadt_NAME&gt;<br>
      &lt;Stadt_PARTEIEN&gt;
      <span v-for="party in kreis.cols" :key="party.label">
        {{party.label}} &lt;Stadt_PARTEIEN_BOLD&gt;{{format(party.percent)}} &lt;&#x2F;Stadt_PARTEIEN_BOLD&gt; ({{format(party.percentOld)}});
      </span>
      &lt;&#x2F;Stadt_PARTEIEN&gt;<br>
      &lt;&#x2F;div&gt;
      <br>
    </div>
    &lt;&#x2F;div&gt;<br>
    &lt;&#x2F;div&gt;<br>
  </div>
</template>

<script>
// import convert from 'xml-js'

export default {
  name: 'kreiseXML',
  components: {
  },
  props: {
    kreise: Array,
    gemeinden: Array
  },
  data () {
    return {
    }
  },
  methods: {
    format (num) {
      if (num>0) {
        return String(num).replace('.',',')
      } else {
        return "n.a."
      }
    }
  },
  computed: {
    landkreise () {
      return this.kreise.slice(5)
    },
    kfs () {
      return this.kreise.slice(0,5)
    }
    // xml () {
    //   const options = {compact: true, ignoreComment: true, spaces: 4}
    //   return convert.js2xml(this.data, options)
    // }
  },
  mounted () {
    // console.log(convert)
  },
  updated () {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.kreis {
  .title {
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>